import React from 'react';
import './MolanaHafizKaleemUllah.css';

const MolanaHafizKaleemUllah = () => {
  return (
    <div className="tutor-detail-page-wrapper" id="tutor-detail-page">
      {/* Premium Hero Section */}
      <section
        className="about-hero"
        style={{
          backgroundImage: `url('${process.env.PUBLIC_URL}/assets/images/home-banner.jpg')`
        }}
      >
        <div className="about-hero__content">
          <h1 className="about-hero__title">Molana Hafiz Kaleem Ullah</h1>
          <nav className="about-hero__breadcrumb" aria-label="breadcrumb">
            <a href="/" className="about-hero__breadcrumb-link">Home</a>
            <span className="about-hero__breadcrumb-separator">&gt;</span>
            <span className="about-hero__breadcrumb-current">Molana Hafiz Kaleem Ullah</span>
          </nav>
        </div>
      </section>

      {/* Profile Section */}
      <div className="tutor-profile-container">
        {/* Left Side: Sticky Profile Sidebar */}
        <aside className="tutor-profile__sidebar">
          <div className="tutor-profile__sidebar-card">
            <div className="tutor-profile__avatar-wrapper">
              <img
                src={`${process.env.PUBLIC_URL}/assets/images/tutor-kaleem.jpg`}
                alt="Molana Hafiz Kaleem Ullah"
                className="tutor-profile__avatar"
              />
            </div>
            <h2 className="tutor-profile__name">Molana Hafiz Kaleem Ullah</h2>
            <p className="tutor-profile__role">Islamic scholar</p>

            <p className="tutor-profile__badge-header">Arabic Language &amp; Literature:</p>
            <div className="tutor-profile__badge tutor-profile__badge--large">
              Hifzul Quran: Quran Memorization
            </div>

            <div className="tutor-profile__badges-row">
              <span className="tutor-profile__badge-tag">Rhetoric</span>
              <span className="tutor-profile__badge-tag">Grammar (Nahw)</span>
              <span className="tutor-profile__badge-tag">Syntax (Sarf)</span>
            </div>

            <a href="/free-trial/" className="tutor-profile__btn-primary">
              Book Free Trial &rarr;
            </a>

            <a href="/our-tutors/" className="tutor-profile__btn-secondary">
              All Our Tutors &rarr;
            </a>
          </div>
        </aside>

        {/* Right Side: Scrolling Content */}
        <main className="tutor-profile__content">
          {/* About Card */}
          <div className="tutor-profile__card">
            <div className="tutor-profile__card-header">
              <svg className="tutor-profile__card-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" />
              </svg>
              <h2 className="tutor-profile__card-title">About Molana Hafiz Kaleem Ullah</h2>
            </div>

            <p className="tutor-profile__bio">
              Molana Hafiz Kaleem Ullah is a qualified Islamic scholar specializing in teaching Quran and core Islamic subjects through structured and easy-to-understand online lessons. He has expertise in Arabic language (Nahw &amp; Sarf), Hifzul Quran, Hadith, Fiqh, Tafsir, and Aqeedah, helping students build both recitation and understanding. He also incorporates Logic (Mantiq) to improve critical thinking and holds specialization in Seerat-un-Nabi (S.A.W). His teaching approach is student-focused, ensuring personalized guidance for effective and engaging learning.
            </p>

            {/* Subjects Grid */}
            <div className="tutor-profile__subjects-grid">
              {/* Subject 1 */}
              <div className="tutor-subject-card">
                <div className="tutor-subject-card__icon-wrapper">
                  <svg className="tutor-subject-card__icon" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H6v-1.5c0-1.99 4-3 6-3s6 1.01 6 3V18z" />
                  </svg>
                </div>
                <div className="tutor-subject-card__info">
                  <h3 className="tutor-subject-card__title">Hadith Studies:</h3>
                  <p className="tutor-subject-card__desc">Detailed study of Prophet Muhammad's (PBUH) traditions.</p>
                </div>
              </div>

              {/* Subject 2 */}
              <div className="tutor-subject-card">
                <div className="tutor-subject-card__icon-wrapper">
                  <svg className="tutor-subject-card__icon" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3" />
                  </svg>
                </div>
                <div className="tutor-subject-card__info">
                  <h3 className="tutor-subject-card__title">Fiqh and Usul-al-Fiqh:</h3>
                  <p className="tutor-subject-card__desc">Islamic Law and its principles.</p>
                </div>
              </div>

              {/* Subject 3 */}
              <div className="tutor-subject-card">
                <div className="tutor-subject-card__icon-wrapper">
                  <svg className="tutor-subject-card__icon" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M9.663 17h4.673M12 3v1m6.364 .364l-.707 .707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                  </svg>
                </div>
                <div className="tutor-subject-card__info">
                  <h3 className="tutor-subject-card__title">Logic &amp; Philosophy (Mantiq/Hikmah):</h3>
                  <p className="tutor-subject-card__desc">Islamic Theology.</p>
                </div>
              </div>

              {/* Subject 4 */}
              <div className="tutor-subject-card">
                <div className="tutor-subject-card__icon-wrapper">
                  <svg className="tutor-subject-card__icon" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.907c.961 0 1.36 1.24.588 1.81l-3.97 2.883a1 1 0 00-.364 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.971-2.883a1 1 0 00-1.178 0l-3.97 2.883c-.783.57-1.838-.197-1.539-1.118l1.518-4.674a1 1 0 00-.364-1.118L2.49 10.017c-.773-.57-.373-1.81.588-1.81h4.907a1 1 0 00.95-.69l1.519-4.674z" />
                  </svg>
                </div>
                <div className="tutor-subject-card__info">
                  <h3 className="tutor-subject-card__title">Aqeedah:</h3>
                  <p className="tutor-subject-card__desc">Islamic Theology.</p>
                </div>
              </div>

              {/* Subject 5 */}
              <div className="tutor-subject-card">
                <div className="tutor-subject-card__icon-wrapper">
                  <svg className="tutor-subject-card__icon" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                  </svg>
                </div>
                <div className="tutor-subject-card__info">
                  <h3 className="tutor-subject-card__title">Specialization in Islamic studies of Seeratun Nabi (S.A.W)</h3>
                  <p className="tutor-subject-card__desc">Classical critical thinking tools.</p>
                </div>
              </div>

              {/* Subject 6 */}
              <div className="tutor-subject-card">
                <div className="tutor-subject-card__icon-wrapper">
                  <svg className="tutor-subject-card__icon" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                  </svg>
                </div>
                <div className="tutor-subject-card__info">
                  <h3 className="tutor-subject-card__title">Tafsir:</h3>
                  <p className="tutor-subject-card__desc">Interpretation of the Quran.</p>
                </div>
              </div>
            </div>
          </div>

          {/* Teaching Methodology Card */}
          <div className="tutor-profile__card">
            <div className="tutor-profile__card-header">
              <svg className="tutor-profile__card-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" />
              </svg>
              <h2 className="tutor-profile__card-title">Teaching Methodology</h2>
            </div>

            <p className="tutor-profile__bio">
              Molana Hafiz Kaleem Ullah follows a structured and student-focused teaching methodology designed for effective online learning. He starts by assessing the student's level and then creates a personalized plan for Quran recitation, memorization, or Islamic studies. His approach combines clear explanations, practical examples, and regular revision to ensure strong understanding and retention. He emphasizes proper Tajweed, consistency, and interactive sessions to keep students engaged and progressing steadily.
            </p>

            {/* Features list */}
            <div className="tutor-profile__features-list">
              <div className="tutor-profile__feature-row">
                <div className="tutor-profile__check-icon-wrapper">
                  <svg className="tutor-profile__check-icon" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                  </svg>
                </div>
                <div className="tutor-profile__feature-item-text">
                  <strong>Tailored Learning Plans:</strong>
                  <span>Customized lessons for international students of all levels.</span>
                </div>
              </div>

              <div className="tutor-profile__feature-row">
                <div className="tutor-profile__check-icon-wrapper">
                  <svg className="tutor-profile__check-icon" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                  </svg>
                </div>
                <div className="tutor-profile__feature-item-text">
                  <strong>Innovative Methods:</strong>
                  <span>Uses creative techniques to keep students motivated and engaged.</span>
                </div>
              </div>

              <div className="tutor-profile__feature-row">
                <div className="tutor-profile__check-icon-wrapper">
                  <svg className="tutor-profile__check-icon" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                  </svg>
                </div>
                <div className="tutor-profile__feature-item-text">
                  <strong>Correction &amp; Fluency:</strong>
                  <span>Focuses on correcting pronunciation errors patiently until mastery.</span>
                </div>
              </div>

              <div className="tutor-profile__feature-row">
                <div className="tutor-profile__check-icon-wrapper">
                  <svg className="tutor-profile__check-icon" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                  </svg>
                </div>
                <div className="tutor-profile__feature-item-text">
                  <strong>Student Retention:</strong>
                  <span>Known for building strong bonds with students, encouraging long-term learning.</span>
                </div>
              </div>

              <div className="tutor-profile__feature-row">
                <div className="tutor-profile__check-icon-wrapper">
                  <svg className="tutor-profile__check-icon" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                  </svg>
                </div>
                <div className="tutor-profile__feature-item-text">
                  <strong>Specialization:</strong>
                  <span>Specialization in Islamic studies of Seeratun Nabi (S.A.W).</span>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>

      {/* Specially Designed Quran Courses Section */}
      <section className="tutor-courses-section">
        <div className="tutor-courses__container">
          <h2 className="tutor-courses__heading">
            Our Specially Designed Quran Courses To Improve<br />Quranic Education
          </h2>

          <div className="tutor-courses__grid">
            {/* Card 1 */}
            <a href="/noorani-qaida-course/" className="tutor-courses__card">
              <div className="tutor-courses__icon-wrapper">
                <svg aria-hidden="true" className="tutor-courses__icon" viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M542.22 32.05c-54.8 3.11-163.72 14.43-230.96 55.59-4.64 2.84-7.27 7.89-7.27 13.17v363.87c0 11.55 12.63 18.85 23.28 13.49 69.18-34.82 169.23-44.32 218.7-46.92 16.89-.89 30.02-14.43 30.02-30.66V62.75c.01-17.71-15.35-31.74-33.77-30.7zM264.73 87.64C197.5 46.48 88.58 35.17 33.78 32.05 15.36 31.01 0 45.04 0 62.75V400.6c0 16.24 13.13 29.78 30.02 30.66 49.49 2.6 149.59 12.11 218.77 46.95 10.62 5.35 23.21-1.94 23.21-13.46V100.63c0-5.29-2.62-10.14-7.27-12.99z"></path></svg>
              </div>
              <h3 className="tutor-courses__card-title">Noorani Qaida Course</h3>
              <p className="tutor-courses__card-text">
                Learn Noorani Qaida online from expert male and female tutors. Perfect for kids and adults who want to build a strong foundation in Quran recitation with proper pronunciation and Tajweed rules.
              </p>
            </a>

            {/* Card 2 */}
            <a href="/online-tajweed-classes-tajweed-course/" className="tutor-courses__card">
              <div className="tutor-courses__icon-wrapper">
                <svg className="tutor-courses__icon" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.42 2.72 6.2 6 6.72V21h2v-3.28c3.28-.52 6-3.3 6-6.72h-1.7z" />
                </svg>
              </div>
              <h3 className="tutor-courses__card-title">Quran Tajweed Classes</h3>
              <p className="tutor-courses__card-text">
                Learn Quran with tajweed online from expert male and female tutors. Whether you are a kid or an adult. We teach everyone with proper guidance.
              </p>
            </a>

            {/* Card 3 */}
            <a href="/quran-reading-classes-online-for-kids-and-adults/" className="tutor-courses__card">
              <div className="tutor-courses__icon-wrapper">
                <svg aria-hidden="true" class="tutor-courses__icon" viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M208 0c-29.9 0-54.7 20.5-61.8 48.2-.8 0-1.4-.2-2.2-.2-35.3 0-64 28.7-64 64 0 4.8.6 9.5 1.7 14C52.5 138 32 166.6 32 200c0 12.6 3.2 24.3 8.3 34.9C16.3 248.7 0 274.3 0 304c0 33.3 20.4 61.9 49.4 73.9-.9 4.6-1.4 9.3-1.4 14.1 0 39.8 32.2 72 72 72 4.1 0 8.1-.5 12-1.2 9.6 28.5 36.2 49.2 68 49.2 39.8 0 72-32.2 72-72V64c0-35.3-28.7-64-64-64zm368 304c0-29.7-16.3-55.3-40.3-69.1 5.2-10.6 8.3-22.3 8.3-34.9 0-33.4-20.5-62-49.7-74 1-4.5 1.7-9.2 1.7-14 0-35.3-28.7-64-64-64-.8 0-1.5.2-2.2.2C422.7 20.5 397.9 0 368 0c-35.3 0-64 28.6-64 64v376c0 39.8 32.2 72 72 72 31.8 0 58.4-20.7 68-49.2 3.9.7 7.9 1.2 12 1.2 39.8 0 72-32.2 72-72 0-4.8-.5-9.5-1.4-14.1 29-12 49.4-40.6 49.4-73.9z"></path></svg>
              </div>
              <h3 className="tutor-courses__card-title">Quran Reading Classes Online</h3>
              <p className="tutor-courses__card-text">
                Get online Quran recitation classes with Juzz by Juzz to learn and improve your Quran reading capabilities, no matter if you are an adult or a kid.
              </p>
            </a>

            {/* Card 4 */}
            <a href="/quran-memorization-classes-course/" className="tutor-courses__card">
              <div className="tutor-courses__icon-wrapper">
                <svg className="tutor-courses__icon" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.42 2.72 6.2 6 6.72V21h2v-3.28c3.28-.52 6-3.3 6-6.72h-1.7z" />
                </svg>
              </div>
              <h3 className="tutor-courses__card-title">Quran Memorization Classes</h3>
              <p className="tutor-courses__card-text">
                Our Quran memorization course intends to help the students to memorize the Holy Quran with experienced and professional Huffaz.
              </p>
            </a>

            {/* Card 5 */}
            <a href="/quran-translation-classes/" className="tutor-courses__card">
              <div className="tutor-courses__icon-wrapper">
                <svg aria-hidden="true" class="tutor-courses__icon" viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M208 0c-29.9 0-54.7 20.5-61.8 48.2-.8 0-1.4-.2-2.2-.2-35.3 0-64 28.7-64 64 0 4.8.6 9.5 1.7 14C52.5 138 32 166.6 32 200c0 12.6 3.2 24.3 8.3 34.9C16.3 248.7 0 274.3 0 304c0 33.3 20.4 61.9 49.4 73.9-.9 4.6-1.4 9.3-1.4 14.1 0 39.8 32.2 72 72 72 4.1 0 8.1-.5 12-1.2 9.6 28.5 36.2 49.2 68 49.2 39.8 0 72-32.2 72-72V64c0-35.3-28.7-64-64-64zm368 304c0-29.7-16.3-55.3-40.3-69.1 5.2-10.6 8.3-22.3 8.3-34.9 0-33.4-20.5-62-49.7-74 1-4.5 1.7-9.2 1.7-14 0-35.3-28.7-64-64-64-.8 0-1.5.2-2.2.2C422.7 20.5 397.9 0 368 0c-35.3 0-64 28.6-64 64v376c0 39.8 32.2 72 72 72 31.8 0 58.4-20.7 68-49.2 3.9.7 7.9 1.2 12 1.2 39.8 0 72-32.2 72-72 0-4.8-.5-9.5-1.4-14.1 29-12 49.4-40.6 49.4-73.9z"></path></svg>
              </div>
              <h3 className="tutor-courses__card-title">Quran Translation Classes Online</h3>
              <p className="tutor-courses__card-text">
                This course is especially designed for students who want to learn to translate Quran so that they are able to understand the meaning of the verses of Quran.
              </p>
            </a>
          </div>
        </div>
      </section>

      {/* Testimonials Section: Their Stories Speak For Us */}
      <section className="tutor-stories-section">
        <div className="tutor-stories__container">
          <div className="tutor-stories__badge-wrapper">
            <span className="tutor-stories__badge">Real Students, Real Results</span>
          </div>

          <h2 className="tutor-stories__heading">Their Stories Speak For Us</h2>

          <p className="tutor-stories__subtitle">
            Real Students, Real Progress. Every Story Below Is From A Verified Student Of Al Quran Lesson.
          </p>

          <div className="tutor-stories__grid">
            {/* Story 1 */}
            <div className="tutor-stories__card">
              <div className="tutor-stories__quote-icon">“</div>
              <p className="tutor-stories__text">
                My daughter was struggling with basic Arabic letters. After just 4 months with her tutor, she can read the Quran fluently. The one-on-one attention made all the difference — her confidence has completely transformed.
              </p>
              <div className="tutor-stories__divider"></div>
              <div className="tutor-stories__footer">
                <div className="tutor-stories__student-info">
                  <span className="tutor-stories__student-name">Sarah M</span>
                  <p className="tutor-stories__student-meta">Texas, USA &middot; Parent</p>
                </div>
                <span className="tutor-stories__duration-badge">4 months</span>
              </div>
            </div>

            {/* Story 2 */}
            <div className="tutor-stories__card">
              <div className="tutor-stories__quote-icon">“</div>
              <p className="tutor-stories__text">
                I started as a complete beginner at age 35. I was worried it would be too late. Ustadh Ahmed was incredibly patient and within 6 months I completed my first Juz with proper Tajweed. Alhamdulillah.
              </p>
              <div className="tutor-stories__divider"></div>
              <div className="tutor-stories__footer">
                <div className="tutor-stories__student-info">
                  <span className="tutor-stories__student-name">Khalid A.</span>
                  <p className="tutor-stories__student-meta">Ontario, Canada &middot; Adult</p>
                </div>
                <span className="tutor-stories__duration-badge">6 months</span>
              </div>
            </div>

            {/* Story 3 */}
            <div className="tutor-stories__card">
              <div className="tutor-stories__quote-icon">“</div>
              <p className="tutor-stories__text">
                Both my sons (ages 7 and 10) take classes here. The female tutor option was very important for my daughter too. Scheduling is flexible and they never missed a class in 8 months. Highly recommend.
              </p>
              <div className="tutor-stories__divider"></div>
              <div className="tutor-stories__footer">
                <div className="tutor-stories__student-info">
                  <span className="tutor-stories__student-name">Fatima R.</span>
                  <p className="tutor-stories__student-meta">New York, USA &middot; Parent</p>
                </div>
                <span className="tutor-stories__duration-badge">8 months</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <div
        className="tutor-parallax-wrapper"
        style={{
          '--bg-parallax': `url('${process.env.PUBLIC_URL}/assets/images/Hero-4.jpg')`
        }}
      >
        <section className="tutor-how-it-works-section" id="how-it-works">
          <div className="tutor-how-it-works__container">
            <div className="tutor-how-it-works__badge">HOW IT WORKS</div>

            <h2 className="tutor-how-it-works__title">
              How To Start Online Quran Classes In 3 Simple Steps
            </h2>

            <div className="tutor-how-it-works__steps-container">
              {/* Step 1 */}
              <div className="tutor-how-it-works__step">
                <div className="tutor-how-it-works__icon-wrapper">
                  <svg className="tutor-how-it-works__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
                  </svg>
                </div>
                <h3 className="tutor-how-it-works__step-num">Step 1</h3>
                <h4 className="tutor-how-it-works__step-title">Book Your Free Trial</h4>
                <p className="tutor-how-it-works__step-desc">
                  Fill out our simple form with your name, location, course interest, and preferred time. It takes less than 2 minutes.
                </p>
              </div>

              {/* Step 2 */}
              <div className="tutor-how-it-works__step">
                <div className="tutor-how-it-works__icon-wrapper">
                  <svg className="tutor-how-it-works__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                  </svg>
                </div>
                <h3 className="tutor-how-it-works__step-num">Step 2</h3>
                <h4 className="tutor-how-it-works__step-title">Get Matched with Your Tutor</h4>
                <p className="tutor-how-it-works__step-desc">
                  We match you or your child with a certified tutor based on your level, gender preference, and schedule. Your first session is arranged within 24 hours.
                </p>
              </div>

              {/* Step 3 */}
              <div className="tutor-how-it-works__step">
                <div className="tutor-how-it-works__icon-wrapper">
                  <svg className="tutor-how-it-works__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                  </svg>
                </div>
                <h3 className="tutor-how-it-works__step-num">Step 3</h3>
                <h4 className="tutor-how-it-works__step-title">Start Learning &amp; Track Progress</h4>
                <p className="tutor-how-it-works__step-desc">
                  Attend your live one-on-one sessions, receive feedback after every class, and track measurable progress through our structured curriculum. Your journey begins on Day 1.
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default MolanaHafizKaleemUllah;

